import request from '@/utils/ajax';

//只有增加,没有修改
export function addParamsQrcode(data){
  return request({
    url: `/wx/manage/wxQrCode/createTicket`,
    method: 'post',
    data: data,
  });
}

export function deleteParamsQrcode(data){
  return request({
    url: `/wx/manage/wxQrCode/delete`,
    method: 'post',
    data: data,
  });
}
